/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';
import { MDCDialog } from "@material/dialog/";
import Button from '../material-button';
/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */

import '@material/dialog/mdc-dialog.scss';
import './index.scss';
/**
 * Create the component.
 */
export default class Dialog extends Component {
  constructor() {
    super();
    this.componentName = "dialog";
    this._onAccept = this._onAccept.bind(this);
    this._onCancel = this._onCancel.bind(this);

  }
  componentDidMount() {
    this.MDComponent = new MDCDialog(this.control);
    this.MDComponent.listen("MDCDialog:accept", this._onAccept);
    this.MDComponent.listen("MDCDialog:cancel", this._onCancel);
  }
  componentWillUnmount() {
    this.MDComponent.unlisten("MDCDialog:accept", this._onAccept);
    this.MDComponent.unlisten("MDCDialog:cancel", this._onCancel);
    this.MDComponent.destroy && this.MDComponent.destroy();
  }
  _onAccept(e) {
    if (this.props.onAccept) {
      this.props.onAccept(e);
    }
  }
  _onCancel(e) {
    if (this.props.onCancel) {
      this.props.onCancel(e);
    }
  }
 render({
   'class': className,
   children,
   full,
   ...props
 }){
   const classes = classnames('mdc-dialog__surface', {
     'mdc-dialog__full': full
   }, className);
   const dialogClasses = classnames('mdc-dialog',{
     'mdc-dialog--open': props.open
   },className);
  return(
    <aside class={dialogClasses} 
      role="alertdialog" ref={control => {
        this.control = control;
      }}
      {...props}
    >
      <div class={classes}>{children}</div>
      <div className="mdc-dialog__backdrop" />
    </aside>
  );
}

}

class DialogHeader extends Component {
  constructor() {
    super();
    this.componentName = "dialog__header";
  }
  render({
    'class': className,
    children,
    ...props
  }){
    const classes = classnames('mdc-dialog__header', {

 }, className);
 return(
   <header {...props} class={classes}>
     <h2 className="mdc-dialog__header__title">{children}</h2>
   </header>
 );
}
}
/**
 * @prop scrollable = false
 */
class DialogBody extends Component {
  constructor() {
    super();
    this.componentName = "dialog__body";
    this._mdcProps = ["scrollable"];
  }
  render({
    'class': className,
    children,
    scrollable,
    ...props
  }){
    const classes = classnames('mdc-dialog__body', {
'mdc-dialog__body--scrollable':scrollable
 }, className);
 return(
    <section {...props} class={classes}>
      {children}
    </section>
 );
}
}

class DialogFooter extends Component {
  constructor() {
    super();
    this.componentName = "dialog__footer";
  }
  render({
    'class': className,
    children,
    sticky,
    ...props
  }){
    const classes = classnames('mdc-dialog__footer', {
      'mdc-dialog__footer__sticky': sticky

 }, className);
 return(
   <footer {...props} class={classes}>{children}</footer>
 );
}

}

/**
 * @prop cancel = false
 * @prop accept = false
 */
class DialogFooterButton extends Button {
  constructor() {
    super();
    this.componentName = "dialog__footer__button";
    this._mdcProps = ["cancel", "accept", "disable"];
  }
  render({
    'class': className,
    compact,
    primary,
    accent,
    raised,
    dense,
    children,
    cancel,
    accept,
    disable,
    ...props
  }){
    const classes = classnames('mdc-dialog__footer__button mdc-button',
     {'mdc-dialog__footer__button--cancel':cancel,
      'mdc-dialog__footer__button--accept':accept,
      'mdc-dialog__footer__button--disable':disable,
      'mdc-button--compact': compact,
      'mdc-button--primary': primary,
      'mdc-button--accent': accent,
      'mdc-button--raised': raised,
      'mdc-button--dense': dense
 }, className);
 return(
   <button
     {...props} class={classes}
     ref={control => {
       this.control = control;
     }}
   >
     {children}
   </button>
 );
}
}

Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
Dialog.FooterButton = DialogFooterButton;



// WEBPACK FOOTER //
// ../q-mdc/elements/material-dialog/index.js